import useMediaQuery from '@/helpers/hooks/useMediaQuery';
import { desktop } from '@/helpers/utils/screensizes';
const ProjectLayout = ({ children, activeTab, projectForm }: { children: React.ReactNode; activeTab: number; projectForm: any; }) => {
  const [isDesktopSize] = useMediaQuery(desktop);
  if (!isDesktopSize) return null;

  return (
    <>
      <div
        id="project-builder"
       className='md:px-[18px] xl:px-0 2xl:px-[18px] pt-[18px]'
      >
        <div className='md:flex-1'>{children}</div>
      </div>
    </>
  );
};
export default ProjectLayout;
